import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3329e28b = () => interopDefault(import('../_theme/pages/Home.vue' /* webpackChunkName: "" */))
const _50d2597a = () => interopDefault(import('../_theme/pages/Article.vue' /* webpackChunkName: "_theme/pages/Article" */))
const _0230a390 = () => interopDefault(import('../_theme/pages/ArticleList.vue' /* webpackChunkName: "_theme/pages/ArticleList" */))
const _05fdcdac = () => interopDefault(import('../_theme/pages/Category.vue' /* webpackChunkName: "_theme/pages/Category" */))
const _3ac84572 = () => interopDefault(import('../_theme/pages/Checkout.vue' /* webpackChunkName: "" */))
const _15bc3cbe = () => interopDefault(import('../_theme/pages/Checkout/Billing.vue' /* webpackChunkName: "" */))
const _9728e26e = () => interopDefault(import('../_theme/pages/Checkout/Payment.vue' /* webpackChunkName: "" */))
const _3cf4dd0a = () => interopDefault(import('../_theme/pages/Checkout/Shipping.vue' /* webpackChunkName: "" */))
const _69d945bc = () => interopDefault(import('../_theme/pages/Checkout/ThankYou.vue' /* webpackChunkName: "" */))
const _21ec09f1 = () => interopDefault(import('../_theme/pages/Checkouts.vue' /* webpackChunkName: "_theme/pages/Checkouts" */))
const _1f72ef7c = () => interopDefault(import('../_theme/pages/Contactus.vue' /* webpackChunkName: "_theme/pages/Contactus" */))
const _595aaee5 = () => interopDefault(import('../_theme/pages/MyAccount.vue' /* webpackChunkName: "_theme/pages/MyAccount" */))
const _7b8145fe = () => interopDefault(import('../_theme/pages/MyAccount/BillingDetails.vue' /* webpackChunkName: "_theme/pages/MyAccount/BillingDetails" */))
const _05336b15 = () => interopDefault(import('../_theme/pages/MyAccount/DistributorDetails.vue' /* webpackChunkName: "_theme/pages/MyAccount/DistributorDetails" */))
const _1b325ebf = () => interopDefault(import('../_theme/pages/MyAccount/MyNewsletter.vue' /* webpackChunkName: "_theme/pages/MyAccount/MyNewsletter" */))
const _104aca93 = () => interopDefault(import('../_theme/pages/MyAccount/MyProfile.vue' /* webpackChunkName: "_theme/pages/MyAccount/MyProfile" */))
const _b6119d2a = () => interopDefault(import('../_theme/pages/MyAccount/MyWishList.vue' /* webpackChunkName: "_theme/pages/MyAccount/MyWishList" */))
const _1310ffc0 = () => interopDefault(import('../_theme/pages/MyAccount/OrderHistory.vue' /* webpackChunkName: "_theme/pages/MyAccount/OrderHistory" */))
const _3587aaea = () => interopDefault(import('../_theme/pages/MyAccount/ShippingDetails.vue' /* webpackChunkName: "_theme/pages/MyAccount/ShippingDetails" */))
const _71b6961a = () => interopDefault(import('../_theme/pages/Product.vue' /* webpackChunkName: "_theme/pages/Product" */))
const _be7b02e4 = () => interopDefault(import('../_theme/pages/ResetPassword.vue' /* webpackChunkName: "" */))
const _5a7acb48 = () => interopDefault(import('../_theme/pages/Xpay.vue' /* webpackChunkName: "_theme/pages/Xpay" */))
const _6dd3ad72 = () => interopDefault(import('../pages/Article.vue' /* webpackChunkName: "" */))
const _0df4cf85 = () => interopDefault(import('../pages/ArticleList.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/ar-EG",
    component: _3329e28b,
    name: "home___ar-EG"
  }, {
    path: "/bn-BD",
    component: _3329e28b,
    name: "home___bn-BD"
  }, {
    path: "/de-DE",
    component: _3329e28b,
    name: "home___de-DE"
  }, {
    path: "/en-US",
    component: _3329e28b,
    name: "home___en-US"
  }, {
    path: "/es-ES",
    component: _3329e28b,
    name: "home___es-ES"
  }, {
    path: "/fr-FR",
    component: _3329e28b,
    name: "home___fr-FR"
  }, {
    path: "/hi-IN",
    component: _3329e28b,
    name: "home___hi-IN"
  }, {
    path: "/id-ID",
    component: _3329e28b,
    name: "home___id-ID"
  }, {
    path: "/it-IT",
    component: _3329e28b,
    name: "home___it-IT"
  }, {
    path: "/ja-JP",
    component: _3329e28b,
    name: "home___ja-JP"
  }, {
    path: "/ko-KR",
    component: _3329e28b,
    name: "home___ko-KR"
  }, {
    path: "/ms-MY",
    component: _3329e28b,
    name: "home___ms-MY"
  }, {
    path: "/pt-PT",
    component: _3329e28b,
    name: "home___pt-PT"
  }, {
    path: "/ru-RU",
    component: _3329e28b,
    name: "home___ru-RU"
  }, {
    path: "/th-TH",
    component: _3329e28b,
    name: "home___th-TH"
  }, {
    path: "/vi-VN",
    component: _3329e28b,
    name: "home___vi-VN"
  }, {
    path: "/zh-CN",
    component: _3329e28b,
    name: "home___zh-CN"
  }, {
    path: "/zh-TW",
    component: _3329e28b,
    name: "home___zh-TW"
  }, {
    path: "/ar-EG/Article",
    component: _50d2597a,
    name: "Article___ar-EG"
  }, {
    path: "/ar-EG/ArticleList",
    component: _0230a390,
    name: "ArticleList___ar-EG"
  }, {
    path: "/ar-EG/Category",
    component: _05fdcdac,
    name: "Category___ar-EG"
  }, {
    path: "/ar-EG/checkout",
    component: _3ac84572,
    name: "checkout___ar-EG",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___ar-EG"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___ar-EG"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___ar-EG"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___ar-EG"
    }]
  }, {
    path: "/ar-EG/Checkout",
    component: _3ac84572,
    name: "Checkout___ar-EG",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___ar-EG"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___ar-EG"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___ar-EG"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___ar-EG"
    }]
  }, {
    path: "/ar-EG/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___ar-EG"
  }, {
    path: "/ar-EG/Contactus",
    component: _1f72ef7c,
    name: "Contactus___ar-EG"
  }, {
    path: "/ar-EG/Home",
    component: _3329e28b,
    name: "Home___ar-EG"
  }, {
    path: "/ar-EG/MyAccount",
    component: _595aaee5,
    name: "MyAccount___ar-EG",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___ar-EG"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___ar-EG"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___ar-EG"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___ar-EG"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___ar-EG"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___ar-EG"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___ar-EG"
    }]
  }, {
    path: "/ar-EG/Product",
    component: _71b6961a,
    name: "Product___ar-EG"
  }, {
    path: "/ar-EG/reset-password",
    component: _be7b02e4,
    name: "reset-password___ar-EG"
  }, {
    path: "/ar-EG/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___ar-EG"
  }, {
    path: "/ar-EG/Xpay",
    component: _5a7acb48,
    name: "Xpay___ar-EG"
  }, {
    path: "/bn-BD/Article",
    component: _50d2597a,
    name: "Article___bn-BD"
  }, {
    path: "/bn-BD/ArticleList",
    component: _0230a390,
    name: "ArticleList___bn-BD"
  }, {
    path: "/bn-BD/Category",
    component: _05fdcdac,
    name: "Category___bn-BD"
  }, {
    path: "/bn-BD/checkout",
    component: _3ac84572,
    name: "checkout___bn-BD",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___bn-BD"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___bn-BD"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___bn-BD"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___bn-BD"
    }]
  }, {
    path: "/bn-BD/Checkout",
    component: _3ac84572,
    name: "Checkout___bn-BD",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___bn-BD"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___bn-BD"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___bn-BD"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___bn-BD"
    }]
  }, {
    path: "/bn-BD/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___bn-BD"
  }, {
    path: "/bn-BD/Contactus",
    component: _1f72ef7c,
    name: "Contactus___bn-BD"
  }, {
    path: "/bn-BD/Home",
    component: _3329e28b,
    name: "Home___bn-BD"
  }, {
    path: "/bn-BD/MyAccount",
    component: _595aaee5,
    name: "MyAccount___bn-BD",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___bn-BD"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___bn-BD"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___bn-BD"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___bn-BD"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___bn-BD"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___bn-BD"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___bn-BD"
    }]
  }, {
    path: "/bn-BD/Product",
    component: _71b6961a,
    name: "Product___bn-BD"
  }, {
    path: "/bn-BD/reset-password",
    component: _be7b02e4,
    name: "reset-password___bn-BD"
  }, {
    path: "/bn-BD/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___bn-BD"
  }, {
    path: "/bn-BD/Xpay",
    component: _5a7acb48,
    name: "Xpay___bn-BD"
  }, {
    path: "/de-DE/Article",
    component: _50d2597a,
    name: "Article___de-DE"
  }, {
    path: "/de-DE/ArticleList",
    component: _0230a390,
    name: "ArticleList___de-DE"
  }, {
    path: "/de-DE/Category",
    component: _05fdcdac,
    name: "Category___de-DE"
  }, {
    path: "/de-DE/checkout",
    component: _3ac84572,
    name: "checkout___de-DE",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___de-DE"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___de-DE"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___de-DE"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___de-DE"
    }]
  }, {
    path: "/de-DE/Checkout",
    component: _3ac84572,
    name: "Checkout___de-DE",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___de-DE"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___de-DE"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___de-DE"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___de-DE"
    }]
  }, {
    path: "/de-DE/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___de-DE"
  }, {
    path: "/de-DE/Contactus",
    component: _1f72ef7c,
    name: "Contactus___de-DE"
  }, {
    path: "/de-DE/Home",
    component: _3329e28b,
    name: "Home___de-DE"
  }, {
    path: "/de-DE/MyAccount",
    component: _595aaee5,
    name: "MyAccount___de-DE",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___de-DE"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___de-DE"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___de-DE"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___de-DE"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___de-DE"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___de-DE"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___de-DE"
    }]
  }, {
    path: "/de-DE/Product",
    component: _71b6961a,
    name: "Product___de-DE"
  }, {
    path: "/de-DE/reset-password",
    component: _be7b02e4,
    name: "reset-password___de-DE"
  }, {
    path: "/de-DE/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___de-DE"
  }, {
    path: "/de-DE/Xpay",
    component: _5a7acb48,
    name: "Xpay___de-DE"
  }, {
    path: "/en-US/Article",
    component: _50d2597a,
    name: "Article___en-US"
  }, {
    path: "/en-US/ArticleList",
    component: _0230a390,
    name: "ArticleList___en-US"
  }, {
    path: "/en-US/Category",
    component: _05fdcdac,
    name: "Category___en-US"
  }, {
    path: "/en-US/checkout",
    component: _3ac84572,
    name: "checkout___en-US",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___en-US"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___en-US"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___en-US"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___en-US"
    }]
  }, {
    path: "/en-US/Checkout",
    component: _3ac84572,
    name: "Checkout___en-US",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___en-US"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___en-US"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___en-US"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___en-US"
    }]
  }, {
    path: "/en-US/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___en-US"
  }, {
    path: "/en-US/Contactus",
    component: _1f72ef7c,
    name: "Contactus___en-US"
  }, {
    path: "/en-US/Home",
    component: _3329e28b,
    name: "Home___en-US"
  }, {
    path: "/en-US/MyAccount",
    component: _595aaee5,
    name: "MyAccount___en-US",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___en-US"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___en-US"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___en-US"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___en-US"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___en-US"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___en-US"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___en-US"
    }]
  }, {
    path: "/en-US/Product",
    component: _71b6961a,
    name: "Product___en-US"
  }, {
    path: "/en-US/reset-password",
    component: _be7b02e4,
    name: "reset-password___en-US"
  }, {
    path: "/en-US/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___en-US"
  }, {
    path: "/en-US/Xpay",
    component: _5a7acb48,
    name: "Xpay___en-US"
  }, {
    path: "/es-ES/Article",
    component: _50d2597a,
    name: "Article___es-ES"
  }, {
    path: "/es-ES/ArticleList",
    component: _0230a390,
    name: "ArticleList___es-ES"
  }, {
    path: "/es-ES/Category",
    component: _05fdcdac,
    name: "Category___es-ES"
  }, {
    path: "/es-ES/checkout",
    component: _3ac84572,
    name: "checkout___es-ES",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___es-ES"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___es-ES"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___es-ES"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___es-ES"
    }]
  }, {
    path: "/es-ES/Checkout",
    component: _3ac84572,
    name: "Checkout___es-ES",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___es-ES"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___es-ES"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___es-ES"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___es-ES"
    }]
  }, {
    path: "/es-ES/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___es-ES"
  }, {
    path: "/es-ES/Contactus",
    component: _1f72ef7c,
    name: "Contactus___es-ES"
  }, {
    path: "/es-ES/Home",
    component: _3329e28b,
    name: "Home___es-ES"
  }, {
    path: "/es-ES/MyAccount",
    component: _595aaee5,
    name: "MyAccount___es-ES",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___es-ES"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___es-ES"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___es-ES"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___es-ES"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___es-ES"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___es-ES"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___es-ES"
    }]
  }, {
    path: "/es-ES/Product",
    component: _71b6961a,
    name: "Product___es-ES"
  }, {
    path: "/es-ES/reset-password",
    component: _be7b02e4,
    name: "reset-password___es-ES"
  }, {
    path: "/es-ES/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___es-ES"
  }, {
    path: "/es-ES/Xpay",
    component: _5a7acb48,
    name: "Xpay___es-ES"
  }, {
    path: "/fr-FR/Article",
    component: _50d2597a,
    name: "Article___fr-FR"
  }, {
    path: "/fr-FR/ArticleList",
    component: _0230a390,
    name: "ArticleList___fr-FR"
  }, {
    path: "/fr-FR/Category",
    component: _05fdcdac,
    name: "Category___fr-FR"
  }, {
    path: "/fr-FR/checkout",
    component: _3ac84572,
    name: "checkout___fr-FR",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___fr-FR"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___fr-FR"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___fr-FR"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___fr-FR"
    }]
  }, {
    path: "/fr-FR/Checkout",
    component: _3ac84572,
    name: "Checkout___fr-FR",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___fr-FR"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___fr-FR"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___fr-FR"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___fr-FR"
    }]
  }, {
    path: "/fr-FR/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___fr-FR"
  }, {
    path: "/fr-FR/Contactus",
    component: _1f72ef7c,
    name: "Contactus___fr-FR"
  }, {
    path: "/fr-FR/Home",
    component: _3329e28b,
    name: "Home___fr-FR"
  }, {
    path: "/fr-FR/MyAccount",
    component: _595aaee5,
    name: "MyAccount___fr-FR",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___fr-FR"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___fr-FR"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___fr-FR"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___fr-FR"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___fr-FR"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___fr-FR"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___fr-FR"
    }]
  }, {
    path: "/fr-FR/Product",
    component: _71b6961a,
    name: "Product___fr-FR"
  }, {
    path: "/fr-FR/reset-password",
    component: _be7b02e4,
    name: "reset-password___fr-FR"
  }, {
    path: "/fr-FR/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___fr-FR"
  }, {
    path: "/fr-FR/Xpay",
    component: _5a7acb48,
    name: "Xpay___fr-FR"
  }, {
    path: "/hi-IN/Article",
    component: _50d2597a,
    name: "Article___hi-IN"
  }, {
    path: "/hi-IN/ArticleList",
    component: _0230a390,
    name: "ArticleList___hi-IN"
  }, {
    path: "/hi-IN/Category",
    component: _05fdcdac,
    name: "Category___hi-IN"
  }, {
    path: "/hi-IN/checkout",
    component: _3ac84572,
    name: "checkout___hi-IN",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___hi-IN"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___hi-IN"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___hi-IN"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___hi-IN"
    }]
  }, {
    path: "/hi-IN/Checkout",
    component: _3ac84572,
    name: "Checkout___hi-IN",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___hi-IN"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___hi-IN"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___hi-IN"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___hi-IN"
    }]
  }, {
    path: "/hi-IN/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___hi-IN"
  }, {
    path: "/hi-IN/Contactus",
    component: _1f72ef7c,
    name: "Contactus___hi-IN"
  }, {
    path: "/hi-IN/Home",
    component: _3329e28b,
    name: "Home___hi-IN"
  }, {
    path: "/hi-IN/MyAccount",
    component: _595aaee5,
    name: "MyAccount___hi-IN",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___hi-IN"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___hi-IN"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___hi-IN"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___hi-IN"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___hi-IN"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___hi-IN"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___hi-IN"
    }]
  }, {
    path: "/hi-IN/Product",
    component: _71b6961a,
    name: "Product___hi-IN"
  }, {
    path: "/hi-IN/reset-password",
    component: _be7b02e4,
    name: "reset-password___hi-IN"
  }, {
    path: "/hi-IN/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___hi-IN"
  }, {
    path: "/hi-IN/Xpay",
    component: _5a7acb48,
    name: "Xpay___hi-IN"
  }, {
    path: "/id-ID/Article",
    component: _50d2597a,
    name: "Article___id-ID"
  }, {
    path: "/id-ID/ArticleList",
    component: _0230a390,
    name: "ArticleList___id-ID"
  }, {
    path: "/id-ID/Category",
    component: _05fdcdac,
    name: "Category___id-ID"
  }, {
    path: "/id-ID/checkout",
    component: _3ac84572,
    name: "checkout___id-ID",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___id-ID"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___id-ID"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___id-ID"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___id-ID"
    }]
  }, {
    path: "/id-ID/Checkout",
    component: _3ac84572,
    name: "Checkout___id-ID",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___id-ID"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___id-ID"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___id-ID"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___id-ID"
    }]
  }, {
    path: "/id-ID/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___id-ID"
  }, {
    path: "/id-ID/Contactus",
    component: _1f72ef7c,
    name: "Contactus___id-ID"
  }, {
    path: "/id-ID/Home",
    component: _3329e28b,
    name: "Home___id-ID"
  }, {
    path: "/id-ID/MyAccount",
    component: _595aaee5,
    name: "MyAccount___id-ID",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___id-ID"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___id-ID"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___id-ID"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___id-ID"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___id-ID"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___id-ID"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___id-ID"
    }]
  }, {
    path: "/id-ID/Product",
    component: _71b6961a,
    name: "Product___id-ID"
  }, {
    path: "/id-ID/reset-password",
    component: _be7b02e4,
    name: "reset-password___id-ID"
  }, {
    path: "/id-ID/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___id-ID"
  }, {
    path: "/id-ID/Xpay",
    component: _5a7acb48,
    name: "Xpay___id-ID"
  }, {
    path: "/it-IT/Article",
    component: _50d2597a,
    name: "Article___it-IT"
  }, {
    path: "/it-IT/ArticleList",
    component: _0230a390,
    name: "ArticleList___it-IT"
  }, {
    path: "/it-IT/Category",
    component: _05fdcdac,
    name: "Category___it-IT"
  }, {
    path: "/it-IT/checkout",
    component: _3ac84572,
    name: "checkout___it-IT",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___it-IT"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___it-IT"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___it-IT"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___it-IT"
    }]
  }, {
    path: "/it-IT/Checkout",
    component: _3ac84572,
    name: "Checkout___it-IT",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___it-IT"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___it-IT"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___it-IT"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___it-IT"
    }]
  }, {
    path: "/it-IT/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___it-IT"
  }, {
    path: "/it-IT/Contactus",
    component: _1f72ef7c,
    name: "Contactus___it-IT"
  }, {
    path: "/it-IT/Home",
    component: _3329e28b,
    name: "Home___it-IT"
  }, {
    path: "/it-IT/MyAccount",
    component: _595aaee5,
    name: "MyAccount___it-IT",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___it-IT"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___it-IT"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___it-IT"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___it-IT"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___it-IT"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___it-IT"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___it-IT"
    }]
  }, {
    path: "/it-IT/Product",
    component: _71b6961a,
    name: "Product___it-IT"
  }, {
    path: "/it-IT/reset-password",
    component: _be7b02e4,
    name: "reset-password___it-IT"
  }, {
    path: "/it-IT/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___it-IT"
  }, {
    path: "/it-IT/Xpay",
    component: _5a7acb48,
    name: "Xpay___it-IT"
  }, {
    path: "/ja-JP/Article",
    component: _50d2597a,
    name: "Article___ja-JP"
  }, {
    path: "/ja-JP/ArticleList",
    component: _0230a390,
    name: "ArticleList___ja-JP"
  }, {
    path: "/ja-JP/Category",
    component: _05fdcdac,
    name: "Category___ja-JP"
  }, {
    path: "/ja-JP/checkout",
    component: _3ac84572,
    name: "checkout___ja-JP",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___ja-JP"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___ja-JP"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___ja-JP"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___ja-JP"
    }]
  }, {
    path: "/ja-JP/Checkout",
    component: _3ac84572,
    name: "Checkout___ja-JP",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___ja-JP"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___ja-JP"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___ja-JP"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___ja-JP"
    }]
  }, {
    path: "/ja-JP/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___ja-JP"
  }, {
    path: "/ja-JP/Contactus",
    component: _1f72ef7c,
    name: "Contactus___ja-JP"
  }, {
    path: "/ja-JP/Home",
    component: _3329e28b,
    name: "Home___ja-JP"
  }, {
    path: "/ja-JP/MyAccount",
    component: _595aaee5,
    name: "MyAccount___ja-JP",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___ja-JP"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___ja-JP"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___ja-JP"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___ja-JP"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___ja-JP"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___ja-JP"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___ja-JP"
    }]
  }, {
    path: "/ja-JP/Product",
    component: _71b6961a,
    name: "Product___ja-JP"
  }, {
    path: "/ja-JP/reset-password",
    component: _be7b02e4,
    name: "reset-password___ja-JP"
  }, {
    path: "/ja-JP/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___ja-JP"
  }, {
    path: "/ja-JP/Xpay",
    component: _5a7acb48,
    name: "Xpay___ja-JP"
  }, {
    path: "/ko-KR/Article",
    component: _50d2597a,
    name: "Article___ko-KR"
  }, {
    path: "/ko-KR/ArticleList",
    component: _0230a390,
    name: "ArticleList___ko-KR"
  }, {
    path: "/ko-KR/Category",
    component: _05fdcdac,
    name: "Category___ko-KR"
  }, {
    path: "/ko-KR/checkout",
    component: _3ac84572,
    name: "checkout___ko-KR",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___ko-KR"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___ko-KR"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___ko-KR"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___ko-KR"
    }]
  }, {
    path: "/ko-KR/Checkout",
    component: _3ac84572,
    name: "Checkout___ko-KR",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___ko-KR"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___ko-KR"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___ko-KR"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___ko-KR"
    }]
  }, {
    path: "/ko-KR/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___ko-KR"
  }, {
    path: "/ko-KR/Contactus",
    component: _1f72ef7c,
    name: "Contactus___ko-KR"
  }, {
    path: "/ko-KR/Home",
    component: _3329e28b,
    name: "Home___ko-KR"
  }, {
    path: "/ko-KR/MyAccount",
    component: _595aaee5,
    name: "MyAccount___ko-KR",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___ko-KR"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___ko-KR"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___ko-KR"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___ko-KR"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___ko-KR"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___ko-KR"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___ko-KR"
    }]
  }, {
    path: "/ko-KR/Product",
    component: _71b6961a,
    name: "Product___ko-KR"
  }, {
    path: "/ko-KR/reset-password",
    component: _be7b02e4,
    name: "reset-password___ko-KR"
  }, {
    path: "/ko-KR/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___ko-KR"
  }, {
    path: "/ko-KR/Xpay",
    component: _5a7acb48,
    name: "Xpay___ko-KR"
  }, {
    path: "/ms-MY/Article",
    component: _50d2597a,
    name: "Article___ms-MY"
  }, {
    path: "/ms-MY/ArticleList",
    component: _0230a390,
    name: "ArticleList___ms-MY"
  }, {
    path: "/ms-MY/Category",
    component: _05fdcdac,
    name: "Category___ms-MY"
  }, {
    path: "/ms-MY/checkout",
    component: _3ac84572,
    name: "checkout___ms-MY",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___ms-MY"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___ms-MY"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___ms-MY"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___ms-MY"
    }]
  }, {
    path: "/ms-MY/Checkout",
    component: _3ac84572,
    name: "Checkout___ms-MY",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___ms-MY"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___ms-MY"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___ms-MY"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___ms-MY"
    }]
  }, {
    path: "/ms-MY/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___ms-MY"
  }, {
    path: "/ms-MY/Contactus",
    component: _1f72ef7c,
    name: "Contactus___ms-MY"
  }, {
    path: "/ms-MY/Home",
    component: _3329e28b,
    name: "Home___ms-MY"
  }, {
    path: "/ms-MY/MyAccount",
    component: _595aaee5,
    name: "MyAccount___ms-MY",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___ms-MY"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___ms-MY"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___ms-MY"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___ms-MY"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___ms-MY"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___ms-MY"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___ms-MY"
    }]
  }, {
    path: "/ms-MY/Product",
    component: _71b6961a,
    name: "Product___ms-MY"
  }, {
    path: "/ms-MY/reset-password",
    component: _be7b02e4,
    name: "reset-password___ms-MY"
  }, {
    path: "/ms-MY/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___ms-MY"
  }, {
    path: "/ms-MY/Xpay",
    component: _5a7acb48,
    name: "Xpay___ms-MY"
  }, {
    path: "/pt-PT/Article",
    component: _50d2597a,
    name: "Article___pt-PT"
  }, {
    path: "/pt-PT/ArticleList",
    component: _0230a390,
    name: "ArticleList___pt-PT"
  }, {
    path: "/pt-PT/Category",
    component: _05fdcdac,
    name: "Category___pt-PT"
  }, {
    path: "/pt-PT/checkout",
    component: _3ac84572,
    name: "checkout___pt-PT",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___pt-PT"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___pt-PT"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___pt-PT"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___pt-PT"
    }]
  }, {
    path: "/pt-PT/Checkout",
    component: _3ac84572,
    name: "Checkout___pt-PT",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___pt-PT"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___pt-PT"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___pt-PT"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___pt-PT"
    }]
  }, {
    path: "/pt-PT/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___pt-PT"
  }, {
    path: "/pt-PT/Contactus",
    component: _1f72ef7c,
    name: "Contactus___pt-PT"
  }, {
    path: "/pt-PT/Home",
    component: _3329e28b,
    name: "Home___pt-PT"
  }, {
    path: "/pt-PT/MyAccount",
    component: _595aaee5,
    name: "MyAccount___pt-PT",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___pt-PT"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___pt-PT"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___pt-PT"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___pt-PT"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___pt-PT"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___pt-PT"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___pt-PT"
    }]
  }, {
    path: "/pt-PT/Product",
    component: _71b6961a,
    name: "Product___pt-PT"
  }, {
    path: "/pt-PT/reset-password",
    component: _be7b02e4,
    name: "reset-password___pt-PT"
  }, {
    path: "/pt-PT/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___pt-PT"
  }, {
    path: "/pt-PT/Xpay",
    component: _5a7acb48,
    name: "Xpay___pt-PT"
  }, {
    path: "/ru-RU/Article",
    component: _50d2597a,
    name: "Article___ru-RU"
  }, {
    path: "/ru-RU/ArticleList",
    component: _0230a390,
    name: "ArticleList___ru-RU"
  }, {
    path: "/ru-RU/Category",
    component: _05fdcdac,
    name: "Category___ru-RU"
  }, {
    path: "/ru-RU/checkout",
    component: _3ac84572,
    name: "checkout___ru-RU",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___ru-RU"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___ru-RU"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___ru-RU"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___ru-RU"
    }]
  }, {
    path: "/ru-RU/Checkout",
    component: _3ac84572,
    name: "Checkout___ru-RU",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___ru-RU"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___ru-RU"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___ru-RU"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___ru-RU"
    }]
  }, {
    path: "/ru-RU/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___ru-RU"
  }, {
    path: "/ru-RU/Contactus",
    component: _1f72ef7c,
    name: "Contactus___ru-RU"
  }, {
    path: "/ru-RU/Home",
    component: _3329e28b,
    name: "Home___ru-RU"
  }, {
    path: "/ru-RU/MyAccount",
    component: _595aaee5,
    name: "MyAccount___ru-RU",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___ru-RU"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___ru-RU"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___ru-RU"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___ru-RU"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___ru-RU"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___ru-RU"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___ru-RU"
    }]
  }, {
    path: "/ru-RU/Product",
    component: _71b6961a,
    name: "Product___ru-RU"
  }, {
    path: "/ru-RU/reset-password",
    component: _be7b02e4,
    name: "reset-password___ru-RU"
  }, {
    path: "/ru-RU/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___ru-RU"
  }, {
    path: "/ru-RU/Xpay",
    component: _5a7acb48,
    name: "Xpay___ru-RU"
  }, {
    path: "/th-TH/Article",
    component: _50d2597a,
    name: "Article___th-TH"
  }, {
    path: "/th-TH/ArticleList",
    component: _0230a390,
    name: "ArticleList___th-TH"
  }, {
    path: "/th-TH/Category",
    component: _05fdcdac,
    name: "Category___th-TH"
  }, {
    path: "/th-TH/checkout",
    component: _3ac84572,
    name: "checkout___th-TH",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___th-TH"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___th-TH"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___th-TH"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___th-TH"
    }]
  }, {
    path: "/th-TH/Checkout",
    component: _3ac84572,
    name: "Checkout___th-TH",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___th-TH"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___th-TH"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___th-TH"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___th-TH"
    }]
  }, {
    path: "/th-TH/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___th-TH"
  }, {
    path: "/th-TH/Contactus",
    component: _1f72ef7c,
    name: "Contactus___th-TH"
  }, {
    path: "/th-TH/Home",
    component: _3329e28b,
    name: "Home___th-TH"
  }, {
    path: "/th-TH/MyAccount",
    component: _595aaee5,
    name: "MyAccount___th-TH",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___th-TH"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___th-TH"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___th-TH"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___th-TH"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___th-TH"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___th-TH"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___th-TH"
    }]
  }, {
    path: "/th-TH/Product",
    component: _71b6961a,
    name: "Product___th-TH"
  }, {
    path: "/th-TH/reset-password",
    component: _be7b02e4,
    name: "reset-password___th-TH"
  }, {
    path: "/th-TH/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___th-TH"
  }, {
    path: "/th-TH/Xpay",
    component: _5a7acb48,
    name: "Xpay___th-TH"
  }, {
    path: "/vi-VN/Article",
    component: _50d2597a,
    name: "Article___vi-VN"
  }, {
    path: "/vi-VN/ArticleList",
    component: _0230a390,
    name: "ArticleList___vi-VN"
  }, {
    path: "/vi-VN/Category",
    component: _05fdcdac,
    name: "Category___vi-VN"
  }, {
    path: "/vi-VN/checkout",
    component: _3ac84572,
    name: "checkout___vi-VN",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___vi-VN"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___vi-VN"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___vi-VN"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___vi-VN"
    }]
  }, {
    path: "/vi-VN/Checkout",
    component: _3ac84572,
    name: "Checkout___vi-VN",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___vi-VN"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___vi-VN"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___vi-VN"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___vi-VN"
    }]
  }, {
    path: "/vi-VN/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___vi-VN"
  }, {
    path: "/vi-VN/Contactus",
    component: _1f72ef7c,
    name: "Contactus___vi-VN"
  }, {
    path: "/vi-VN/Home",
    component: _3329e28b,
    name: "Home___vi-VN"
  }, {
    path: "/vi-VN/MyAccount",
    component: _595aaee5,
    name: "MyAccount___vi-VN",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___vi-VN"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___vi-VN"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___vi-VN"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___vi-VN"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___vi-VN"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___vi-VN"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___vi-VN"
    }]
  }, {
    path: "/vi-VN/Product",
    component: _71b6961a,
    name: "Product___vi-VN"
  }, {
    path: "/vi-VN/reset-password",
    component: _be7b02e4,
    name: "reset-password___vi-VN"
  }, {
    path: "/vi-VN/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___vi-VN"
  }, {
    path: "/vi-VN/Xpay",
    component: _5a7acb48,
    name: "Xpay___vi-VN"
  }, {
    path: "/zh-CN/Article",
    component: _50d2597a,
    name: "Article___zh-CN"
  }, {
    path: "/zh-CN/ArticleList",
    component: _0230a390,
    name: "ArticleList___zh-CN"
  }, {
    path: "/zh-CN/Category",
    component: _05fdcdac,
    name: "Category___zh-CN"
  }, {
    path: "/zh-CN/checkout",
    component: _3ac84572,
    name: "checkout___zh-CN",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___zh-CN"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___zh-CN"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___zh-CN"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___zh-CN"
    }]
  }, {
    path: "/zh-CN/Checkout",
    component: _3ac84572,
    name: "Checkout___zh-CN",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___zh-CN"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___zh-CN"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___zh-CN"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___zh-CN"
    }]
  }, {
    path: "/zh-CN/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___zh-CN"
  }, {
    path: "/zh-CN/Contactus",
    component: _1f72ef7c,
    name: "Contactus___zh-CN"
  }, {
    path: "/zh-CN/Home",
    component: _3329e28b,
    name: "Home___zh-CN"
  }, {
    path: "/zh-CN/MyAccount",
    component: _595aaee5,
    name: "MyAccount___zh-CN",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___zh-CN"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___zh-CN"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___zh-CN"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___zh-CN"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___zh-CN"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___zh-CN"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___zh-CN"
    }]
  }, {
    path: "/zh-CN/Product",
    component: _71b6961a,
    name: "Product___zh-CN"
  }, {
    path: "/zh-CN/reset-password",
    component: _be7b02e4,
    name: "reset-password___zh-CN"
  }, {
    path: "/zh-CN/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___zh-CN"
  }, {
    path: "/zh-CN/Xpay",
    component: _5a7acb48,
    name: "Xpay___zh-CN"
  }, {
    path: "/zh-TW/Article",
    component: _50d2597a,
    name: "Article___zh-TW"
  }, {
    path: "/zh-TW/ArticleList",
    component: _0230a390,
    name: "ArticleList___zh-TW"
  }, {
    path: "/zh-TW/Category",
    component: _05fdcdac,
    name: "Category___zh-TW"
  }, {
    path: "/zh-TW/checkout",
    component: _3ac84572,
    name: "checkout___zh-TW",
    children: [{
      path: "billing",
      component: _15bc3cbe,
      name: "billing___zh-TW"
    }, {
      path: "payment",
      component: _9728e26e,
      name: "payment___zh-TW"
    }, {
      path: "shipping",
      component: _3cf4dd0a,
      name: "shipping___zh-TW"
    }, {
      path: "thank-you",
      component: _69d945bc,
      name: "thank-you___zh-TW"
    }]
  }, {
    path: "/zh-TW/Checkout",
    component: _3ac84572,
    name: "Checkout___zh-TW",
    children: [{
      path: "Billing",
      component: _15bc3cbe,
      name: "Checkout-Billing___zh-TW"
    }, {
      path: "Payment",
      component: _9728e26e,
      name: "Checkout-Payment___zh-TW"
    }, {
      path: "Shipping",
      component: _3cf4dd0a,
      name: "Checkout-Shipping___zh-TW"
    }, {
      path: "ThankYou",
      component: _69d945bc,
      name: "Checkout-ThankYou___zh-TW"
    }]
  }, {
    path: "/zh-TW/Checkouts",
    component: _21ec09f1,
    name: "Checkouts___zh-TW"
  }, {
    path: "/zh-TW/Contactus",
    component: _1f72ef7c,
    name: "Contactus___zh-TW"
  }, {
    path: "/zh-TW/Home",
    component: _3329e28b,
    name: "Home___zh-TW"
  }, {
    path: "/zh-TW/MyAccount",
    component: _595aaee5,
    name: "MyAccount___zh-TW",
    children: [{
      path: "BillingDetails",
      component: _7b8145fe,
      name: "MyAccount-BillingDetails___zh-TW"
    }, {
      path: "DistributorDetails",
      component: _05336b15,
      name: "MyAccount-DistributorDetails___zh-TW"
    }, {
      path: "MyNewsletter",
      component: _1b325ebf,
      name: "MyAccount-MyNewsletter___zh-TW"
    }, {
      path: "MyProfile",
      component: _104aca93,
      name: "MyAccount-MyProfile___zh-TW"
    }, {
      path: "MyWishList",
      component: _b6119d2a,
      name: "MyAccount-MyWishList___zh-TW"
    }, {
      path: "OrderHistory",
      component: _1310ffc0,
      name: "MyAccount-OrderHistory___zh-TW"
    }, {
      path: "ShippingDetails",
      component: _3587aaea,
      name: "MyAccount-ShippingDetails___zh-TW"
    }]
  }, {
    path: "/zh-TW/Product",
    component: _71b6961a,
    name: "Product___zh-TW"
  }, {
    path: "/zh-TW/reset-password",
    component: _be7b02e4,
    name: "reset-password___zh-TW"
  }, {
    path: "/zh-TW/ResetPassword",
    component: _be7b02e4,
    name: "ResetPassword___zh-TW"
  }, {
    path: "/zh-TW/Xpay",
    component: _5a7acb48,
    name: "Xpay___zh-TW"
  }, {
    path: "/ar-EG/a/:id",
    component: _6dd3ad72,
    name: "a___ar-EG"
  }, {
    path: "/ar-EG/l/:id",
    component: _0df4cf85,
    name: "l___ar-EG"
  }, {
    path: "/ar-EG/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___ar-EG"
  }, {
    path: "/bn-BD/a/:id",
    component: _6dd3ad72,
    name: "a___bn-BD"
  }, {
    path: "/bn-BD/l/:id",
    component: _0df4cf85,
    name: "l___bn-BD"
  }, {
    path: "/bn-BD/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___bn-BD"
  }, {
    path: "/de-DE/a/:id",
    component: _6dd3ad72,
    name: "a___de-DE"
  }, {
    path: "/de-DE/l/:id",
    component: _0df4cf85,
    name: "l___de-DE"
  }, {
    path: "/de-DE/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___de-DE"
  }, {
    path: "/en-US/a/:id",
    component: _6dd3ad72,
    name: "a___en-US"
  }, {
    path: "/en-US/l/:id",
    component: _0df4cf85,
    name: "l___en-US"
  }, {
    path: "/en-US/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___en-US"
  }, {
    path: "/es-ES/a/:id",
    component: _6dd3ad72,
    name: "a___es-ES"
  }, {
    path: "/es-ES/l/:id",
    component: _0df4cf85,
    name: "l___es-ES"
  }, {
    path: "/es-ES/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___es-ES"
  }, {
    path: "/fr-FR/a/:id",
    component: _6dd3ad72,
    name: "a___fr-FR"
  }, {
    path: "/fr-FR/l/:id",
    component: _0df4cf85,
    name: "l___fr-FR"
  }, {
    path: "/fr-FR/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___fr-FR"
  }, {
    path: "/hi-IN/a/:id",
    component: _6dd3ad72,
    name: "a___hi-IN"
  }, {
    path: "/hi-IN/l/:id",
    component: _0df4cf85,
    name: "l___hi-IN"
  }, {
    path: "/hi-IN/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___hi-IN"
  }, {
    path: "/id-ID/a/:id",
    component: _6dd3ad72,
    name: "a___id-ID"
  }, {
    path: "/id-ID/l/:id",
    component: _0df4cf85,
    name: "l___id-ID"
  }, {
    path: "/id-ID/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___id-ID"
  }, {
    path: "/it-IT/a/:id",
    component: _6dd3ad72,
    name: "a___it-IT"
  }, {
    path: "/it-IT/l/:id",
    component: _0df4cf85,
    name: "l___it-IT"
  }, {
    path: "/it-IT/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___it-IT"
  }, {
    path: "/ja-JP/a/:id",
    component: _6dd3ad72,
    name: "a___ja-JP"
  }, {
    path: "/ja-JP/l/:id",
    component: _0df4cf85,
    name: "l___ja-JP"
  }, {
    path: "/ja-JP/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___ja-JP"
  }, {
    path: "/ko-KR/a/:id",
    component: _6dd3ad72,
    name: "a___ko-KR"
  }, {
    path: "/ko-KR/l/:id",
    component: _0df4cf85,
    name: "l___ko-KR"
  }, {
    path: "/ko-KR/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___ko-KR"
  }, {
    path: "/ms-MY/a/:id",
    component: _6dd3ad72,
    name: "a___ms-MY"
  }, {
    path: "/ms-MY/l/:id",
    component: _0df4cf85,
    name: "l___ms-MY"
  }, {
    path: "/ms-MY/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___ms-MY"
  }, {
    path: "/pt-PT/a/:id",
    component: _6dd3ad72,
    name: "a___pt-PT"
  }, {
    path: "/pt-PT/l/:id",
    component: _0df4cf85,
    name: "l___pt-PT"
  }, {
    path: "/pt-PT/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___pt-PT"
  }, {
    path: "/ru-RU/a/:id",
    component: _6dd3ad72,
    name: "a___ru-RU"
  }, {
    path: "/ru-RU/l/:id",
    component: _0df4cf85,
    name: "l___ru-RU"
  }, {
    path: "/ru-RU/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___ru-RU"
  }, {
    path: "/th-TH/a/:id",
    component: _6dd3ad72,
    name: "a___th-TH"
  }, {
    path: "/th-TH/l/:id",
    component: _0df4cf85,
    name: "l___th-TH"
  }, {
    path: "/th-TH/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___th-TH"
  }, {
    path: "/vi-VN/a/:id",
    component: _6dd3ad72,
    name: "a___vi-VN"
  }, {
    path: "/vi-VN/l/:id",
    component: _0df4cf85,
    name: "l___vi-VN"
  }, {
    path: "/vi-VN/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___vi-VN"
  }, {
    path: "/zh-CN/a/:id",
    component: _6dd3ad72,
    name: "a___zh-CN"
  }, {
    path: "/zh-CN/l/:id",
    component: _0df4cf85,
    name: "l___zh-CN"
  }, {
    path: "/zh-CN/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___zh-CN"
  }, {
    path: "/zh-TW/a/:id",
    component: _6dd3ad72,
    name: "a___zh-TW"
  }, {
    path: "/zh-TW/l/:id",
    component: _0df4cf85,
    name: "l___zh-TW"
  }, {
    path: "/zh-TW/my-account/:pageName?",
    component: _595aaee5,
    name: "my-account___zh-TW"
  }, {
    path: "/ar-EG/p/:id/:slug",
    component: _71b6961a,
    name: "product___ar-EG"
  }, {
    path: "/bn-BD/p/:id/:slug",
    component: _71b6961a,
    name: "product___bn-BD"
  }, {
    path: "/de-DE/p/:id/:slug",
    component: _71b6961a,
    name: "product___de-DE"
  }, {
    path: "/en-US/p/:id/:slug",
    component: _71b6961a,
    name: "product___en-US"
  }, {
    path: "/es-ES/p/:id/:slug",
    component: _71b6961a,
    name: "product___es-ES"
  }, {
    path: "/fr-FR/p/:id/:slug",
    component: _71b6961a,
    name: "product___fr-FR"
  }, {
    path: "/hi-IN/p/:id/:slug",
    component: _71b6961a,
    name: "product___hi-IN"
  }, {
    path: "/id-ID/p/:id/:slug",
    component: _71b6961a,
    name: "product___id-ID"
  }, {
    path: "/it-IT/p/:id/:slug",
    component: _71b6961a,
    name: "product___it-IT"
  }, {
    path: "/ja-JP/p/:id/:slug",
    component: _71b6961a,
    name: "product___ja-JP"
  }, {
    path: "/ko-KR/p/:id/:slug",
    component: _71b6961a,
    name: "product___ko-KR"
  }, {
    path: "/ms-MY/p/:id/:slug",
    component: _71b6961a,
    name: "product___ms-MY"
  }, {
    path: "/pt-PT/p/:id/:slug",
    component: _71b6961a,
    name: "product___pt-PT"
  }, {
    path: "/ru-RU/p/:id/:slug",
    component: _71b6961a,
    name: "product___ru-RU"
  }, {
    path: "/th-TH/p/:id/:slug",
    component: _71b6961a,
    name: "product___th-TH"
  }, {
    path: "/vi-VN/p/:id/:slug",
    component: _71b6961a,
    name: "product___vi-VN"
  }, {
    path: "/zh-CN/p/:id/:slug",
    component: _71b6961a,
    name: "product___zh-CN"
  }, {
    path: "/zh-TW/p/:id/:slug",
    component: _71b6961a,
    name: "product___zh-TW"
  }, {
    path: "/ar-EG/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___ar-EG"
  }, {
    path: "/bn-BD/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___bn-BD"
  }, {
    path: "/de-DE/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___de-DE"
  }, {
    path: "/en-US/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___en-US"
  }, {
    path: "/es-ES/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___es-ES"
  }, {
    path: "/fr-FR/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___fr-FR"
  }, {
    path: "/hi-IN/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___hi-IN"
  }, {
    path: "/id-ID/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___id-ID"
  }, {
    path: "/it-IT/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___it-IT"
  }, {
    path: "/ja-JP/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___ja-JP"
  }, {
    path: "/ko-KR/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___ko-KR"
  }, {
    path: "/ms-MY/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___ms-MY"
  }, {
    path: "/pt-PT/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___pt-PT"
  }, {
    path: "/ru-RU/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___ru-RU"
  }, {
    path: "/th-TH/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___th-TH"
  }, {
    path: "/vi-VN/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___vi-VN"
  }, {
    path: "/zh-CN/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___zh-CN"
  }, {
    path: "/zh-TW/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _05fdcdac,
    name: "category___zh-TW"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
